import React from 'react';
import IconProps from '../../icons';

const Check = ({ width = 24, color = 'var(--gray-light-700)', className = '' }: IconProps): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    viewBox='0 0 24 24'
    fill='none'
    className={className}
  >
    <path
      d='M20 6L9 17L4 12'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default Check;
